const items = [
  "ROMACASA",
  "IMMOBILI DI PRESTIGIO",
  "VENDITA & AFFITTO",
  "RESIDENZE ESCLUSIVE",
  "SERVIZI SARTORIALI",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {items.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif-d italic text-2xl sm:text-3xl text-[#000000]/70 whitespace-nowrap px-6">{t}</span>
        <span className="w-1.5 h-1.5 rounded-full bg-[#000000] shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#E0E3E6] bg-[#F1F2F4] py-5 select-none">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
